import { render } from "./MenuEngineeringEditDish.vue?vue&type=template&id=2831b624&ts=true"
import script from "./MenuEngineeringEditDish.vue?vue&type=script&lang=ts"
export * from "./MenuEngineeringEditDish.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.38_typescript@5.9.3__webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__